// Price-in-currency helpers for reception documents.
// purchasePrice (Набавна цена) is always MKD = priceInCurrency × exchangeRate.

type CurrencyLike = { currency?: string; exchangeRate?: number } | null | undefined;

/** MKD per 1 unit of the pricelist currency. MKD, none or an invalid rate → 1. */
export const resolveExchangeRate = (currency?: CurrencyLike): number => {
  if (!currency) return 1;
  if ((currency.currency || '').toUpperCase() === 'MKD') return 1;
  const rate = Number(currency.exchangeRate);
  return Number.isFinite(rate) && rate > 0 ? rate : 1;
};

export const toPurchasePrice = (priceInCurrency: number, rate: number): number =>
  priceInCurrency * rate;

export const toPriceInCurrency = (purchasePrice: number, rate: number): number =>
  rate > 0 ? purchasePrice / rate : purchasePrice;

/**
 * Вредност во валута (PANTHEON „Вредност во …“) = Вредност (со попуст, MKD) ÷ the row's frozen rate.
 * null on rows without a price in currency (legacy / MKD-only rows). Same rule as the server
 * (server/routes/documentLineItem.js parsePriceInCurrency), which stores it.
 */
export const toValueInCurrency = (
  priceInCurrency: unknown,
  priceValueDiscount: number,
  rate: number | null | undefined,
): number | null => {
  if (priceInCurrency === null || priceInCurrency === undefined || priceInCurrency === '') return null;
  const r = rate && rate > 0 ? rate : 1;
  return priceValueDiscount / r;
};
